module.exports = __webpack_public_path__ + "img/dianpu.0d30d54b.jpg";